module.exports = __webpack_public_path__ + "media/images/temp/icon-6-d3c0226babf871035fd0c7fb6c50e7f0.png";